var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.bool_showApp)?_c('div',{staticClass:"block-calculate__preloader"},[_c('div',{staticClass:"loader"},[_vm._v("Loading...")]),_c('p',{staticClass:"preloader_text"},[_vm._v("Калькулятор загружается")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }